<template>
  <el-drawer
    title="预览"
    :visible.sync="drawerVisible"
    direction="rtl"
    size="600px"
    custom-class="preview-drawer"
    @close="$emit('close')"
  >
    <div class="content">
      <div class="mine-box" v-loading="loading">
        <div class="mine-info" :style="{backgroundImage: `url(${data.cardUrl})`}">
          <div class="mine-content">
            <img class="user-btn" src="~/assets/images/mine/avatar.png" alt />
            <div>
              <div class="mine-top">
                <div class="name-title">my heart will go on</div>
              </div>
              <div class="name-box">
                8000积分
                <span decode>&gt;</span>
              </div>
            </div>
          </div>
          <div class="w-code">
            <img src="~/assets/images/mine/wechat.png" />
            <span>会员码</span>
          </div>
        </div>
        <div class="mine-bottom">
          <div class="block-box">
            <div
              class="block-item"
              v-for="(item,index) in blockList"
              :key="index"
            >
              <img :src="item.pic" class="block-pic" />
              <div class="block-des">{{item.des}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { getUserCard } from '@/api/prefer';

export default {
  name: 'Preview',
  data() {
    return {
      drawerVisible: false,
      loading: false,
      data: {},
      blockList: [
        {
          pic: require('../../assets/images/mine/pic1.png'),
          des: '我的券包',
        },
        {
          pic: require('../../assets/images/mine/pic2.png'),
          des: '积分兑换',
        },
        {
          pic: require('../../assets/images/mine/pic3.png'),
          des: '积分记录',
        },
        {
          pic: require('../../assets/images/mine/pic4.png'),
          des: '小票记录',
        },
        {
          pic: require('../../assets/images/mine/pic5.png'),
          des: '个人信息',
        },
        {
          pic: require('../../assets/images/mine/pic6.png'),
          des: '店铺分布',
        },
        {
          pic: require('../../assets/images/mine/pic7.png'),
          des: '店员端',
        },
        {
          pic: require('../../assets/images/mine/pic8.png'),
          des: '联系客服',
        },
      ],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectId: {
      type: Number,
      required: true,
    },
  },
  watch: {
    visible(value) {
      this.drawerVisible = value;
    },
    selectId() {
      this.getUserCard();
    },
  },
  methods: {
    getUserCard() {
      this.loading = true;
      getUserCard().then((res) => {
        if (res.success) {
          this.data = res.data;
          this.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "~assets/css/mixins.styl";
>>>.preview-drawer
  overflow auto !important
.content
  padding 30px 60px
  display flex
  flex-flow row nowrap
  align-items center
  justify-content center
  .mine-box
    width 375px
    height 619px
    position relative
  .mine-info
    width 100%
    height 192px
    background-position center
    background-size cover
    position relative
  .mine-content
    width 100%
    padding 20px 15px
    box-sizing border-box
    flex-row()
  .mine-top
    display flex
    align-items center
  .user-btn
    width 48px
    height 48px
    margin 0
    border-radius 50%
    display flex
    justify-content center
    align-items center
    img
      width 100%
      height 100%
  .user-btn::after
    border 0
  .name-title
    font-size 18px
    color #fff
    margin 12px
    margin-left 12px
    flex 1
    overflow hidden
    span-overflow ellipsis
    white-space nowrap
  .name-box
    margin-left 12px
    color #ffe0ab
    font-size 18px
  .name-box span
    color #fff
  .w-code
    display flex
    flex-direction column
    justify-content center
    align-items center
    position absolute
    right 23px
    bottom 10px
  .w-code img
    width 21px
    height 21px
    display block
  .w-code span
    color #ccc
    font-size 12px
    margin-top 10px
  .mine-bottom
    height 505px
    background linear-gradient(180deg, rgba(34, 34, 34, 1) 0%, rgba(107, 107, 107, 1) 100%)
  .block-box
    width 100%
    padding 21px 15px
    display flex
    flex-direction row
    flex-wrap wrap
  .block-item
    width 86px
    height 62px
    box-sizing border-box
    border-right 1px solid #3d3d3d
    display flex
    align-items center
    flex-direction column
    justify-content flex-end
  .block-box .block-item:nth-child(4n)
    border-right 0
  .block-box .block-item:nth-child(1),
  .block-box .block-item:nth-child(2),
  .block-box .block-item:nth-child(3),
  .block-box .block-item:nth-child(4)
    border-bottom 1px solid #3d3d3d
    justify-content flex-start
  .block-pic
    width 22px
    height 22px
    display block
  .block-des
    color #CCCCCC
    font-size 12px
    margin-top 10px
</style>
